import { fromJS, Map, Set } from 'immutable';
import { deepMerge } from 'nike-ui/src/common/immutable/merge';

export function initialize(db, menuJson) {
    if (!menuJson.items) {
        return db;
    }
    const { sportList, countriesBySport, tournamentsBySlug } = createMenu2(menuJson.items);
    return db
        .updateIn(['nikeone', 'menu', 'sportList'], existing => deepMerge(existing, sportList))
        .updateIn(['nikeone', 'menu', 'countriesBySport'], existing => deepMerge(existing, countriesBySport))
        .setIn(['nikeone', 'menu', 'tournamentsBySlug'], tournamentsBySlug)
        .setIn(['nikeone', 'menu', 'results'], menuJson.request.results);
}

export function initializeToday(db, menuJson) {
    if (!menuJson.items) {
        return db;
    }
    const { sportList, tournamentsBySlug } = createMenu2(menuJson.items);
    return db
        .updateIn(['nikeone', 'todayMenu', 'sportList'], existing => deepMerge(existing, sportList))
        .setIn(['nikeone', 'todayMenu', 'tournamentsBySlug'], tournamentsBySlug);
}

// export function initializeToday(db, menuJson) {
//     if (!menuJson.items) {
//         return db;
//     }
//     const menuData = Immutable.fromJS(menuJson.items);
//     const todayMenu = menuData.map(sportItem => sportItem.update('items', sportTournaments));
//     return db.set('todayMenu', todayMenu);
// }
//
//
//
// export function findSportSlugByBoxId(menu, boxId) {
//     // spoliehame sa nato ze v mape je vzdy najskor sportSlug az potom countrySlugy
//     return menu.get('tournamentsBySlug', Immutable.Map()).findKey((tournaments) => {
//         const boxIds = tournaments.map(i => i.get('boxId'));
//         return boxIds.contains(boxId);
//     });
// }
//
// export function isEmpty(db) {
//     return db.get('menu', 'sportList', Immutable.List()).isEmpty();
// }
//
// function countryList(menuItem) {
//     return menuItem.get('items').filterNot(isTopTournament);
// }
//
// function sportTournaments(items) {
//     const topTournaments = items.filter(isTopTournament);
//     const tournamentsWithDuplicates = topTournaments.concat(items.flatMap(i => i.get('items')));
//     // topovany tournament je v hierarchii 2x, raz ako country (1.level menu) a raz vnutri country(2.level menu), my chceme len ten prvy
//     return tournamentsWithDuplicates.groupBy(x => x.get('boxId')).map(x => x.first()).toList();
// }
//
// function createMenu(menu) {
//     let result = Immutable.Map();
//     const sportList = menu.map(i => i.delete('items'));
//     result = result.set('sportList', sportList);
//
//     const countriesBySlug = menu.flatMap(sport => {
//         const countryItems = countryList(sport);
//         // zoznam krajin priradime sportu ale aj kazdej krajine priradime zoznam krajin do ktoreho patri - lebo ked
//         // vyberieme krajinu podla jej slugu sa bude vyberat zoznam krajin - sport a country slug su zjednotene...
//         const allSlugs = countryItems.map(c => c.get('slug')).push(sport.get('slug'));
//         return allSlugs.map(slug => [slug, countryItems]);
//     });
//     result = result.set('countriesBySlug', Immutable.Map(countriesBySlug));
//
//     const tournamentsBySlug = menu.flatMap(sport => {
//         const sportTours = sportTournaments(sport.get('items'));
//         const countryTours = countryList(sport).map(country => [country.get('slug'), country.get('items')]);
//         return countryTours.unshift([sport.get('slug'), sportTours]);
//     });
//     return result.set('tournamentsBySlug', Immutable.OrderedMap(tournamentsBySlug));
// }

function createMenu2(menuItems) {
    const sportList = [];
    const countriesBySport = {};
    const tournamentsBySlug = {};
    menuItems.forEach(sportItem => {
        const sport = {
            icon: sportItem.icon,
            label: sportItem.label,
            slug: sportItem.slug,
            sportId: sportItem.sportId,
            boxId: sportItem.boxId,
            boxIds: []
        };
        countriesBySport[sportItem.slug] = [];
        tournamentsBySlug[sportItem.slug] = [];
        let dedupe = Set();
        sportItem.items.forEach(countryItem => {
            if (countryItem.items && countryItem.items.length) {
                tournamentsBySlug[countryItem.slug] = [];
                countriesBySport[sportItem.slug].push({ label: countryItem.label, slug: countryItem.slug });
                countryItem.items.forEach(tournamentItem => {
                    tournamentItem.top = false;
                    tournamentsBySlug[countryItem.slug].push(tournamentItem);
                    if (!dedupe.has(tournamentItem.boxId)) {
                        dedupe = dedupe.add(tournamentItem.boxId);
                        tournamentsBySlug[sportItem.slug].push(tournamentItem);
                    }
                });
            } else {
                // country itemy, ktore nemaju svoje (vlastne) itemy => su TOPovane tournamenty
                // ignoruje 'top' flag co chodi z FPP a presetujeme si ho na vlastny
                countryItem.top = true;
                dedupe = dedupe.add(countryItem.boxId);
                tournamentsBySlug[sportItem.slug].push(countryItem);
            }
        });
        sport.boxIds = dedupe;
        sportList.push(sport);
    });
    return {
        sportList: fromJS(sportList),
        countriesBySport: fromJS(countriesBySport),
        tournamentsBySlug: Map(tournamentsBySlug)
    };
}
